import { useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { useAuth } from "../../Hooks/useAuth";
import Sidebar from "../shared/Sidebar";
import Header from "../shared/Header";
import Chatbot from "../chatbot";
import { logout } from "../../utils/authStorage";
import "./PageLayout.css";

function PageLayout({ title, children }) {
  const { isDarkMode } = useTheme();
  const [collapsed, setCollapsed] = useState(false);
  const { username, role } = useAuth();

  const handleLogout = () => logout();

  return (
    <div className={`page ${isDarkMode ? "dark" : "light"}`}>
      <Sidebar
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((prev) => !prev)}
        isDarkMode={isDarkMode}
        username={username}
        role={role}
        onLogout={handleLogout}
      />
      <main className="main-content">
        <Header title={title} />
        <div className="main-divider" />
        {children}
      </main>
      <Chatbot />
    </div>
  );
}

export default PageLayout;
